import React, { useContext, useCallback } from 'react';
import { useSelector, connect } from 'react-redux';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import Card from './component';

import { DispatchingContext } from 'modules/ownership-dispatching';
import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['booking_number', 'logistics_operator_code', 'reference_number', 'seal_number'];

const AssignedJourneyCard = (props) => {
  const {
    onClick,
    journeyId,
    booking_number,
    logistics_operator_code,
    reference_number,
    seal_number,
  } = props;
  const { selectedJourneys, addJourney, removeJourney } = useContext(DispatchingContext) || {};
  const userGroups = useSelector((state) => state.me.groups);

  const isDispatcher = (userGroups || []).includes('Dispatcher');
  const hasDispatchingContext = !!addJourney && !!removeJourney;

  const onChangeCheckbox = useCallback(
    (_, { value }) => {
      if (value) {
        addJourney(journeyId);
        return;
      }

      removeJourney(journeyId);
    },
    [journeyId, addJourney, removeJourney]
  );

  const onCardClick = useCallback(
    (e) => {
      e.stopPropagation();
      onClick(journeyId);
    },
    [onClick, journeyId]
  );

  return (
    <Card
      onChangeCheckbox={onChangeCheckbox}
      onCardClick={onCardClick}
      isSelected={(selectedJourneys || []).includes(journeyId)}
      journeyId={journeyId}
      showCheckbox={isDispatcher && hasDispatchingContext}
      booking_number={booking_number}
      logistics_operator_code={logistics_operator_code}
      reference_number={reference_number}
      seal_number={seal_number}
    />
  );
};

AssignedJourneyCard.propTypes = {
  onClick: PropTypes.func.isRequired,
  journeyId: PropTypes.number.isRequired,
  booking_number: PropTypes.string,
  logistics_operator_code: PropTypes.string,
  reference_number: PropTypes.string,
  seal_number: PropTypes.string,
};

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { booking_number, logistics_operator_code, reference_number, seal_number } =
      props.selectors.getJourneyFields(state, props.journeyId, fields);

    return {
      booking_number,
      logistics_operator_code,
      reference_number,
      seal_number,
    };
  })
);

export default enhance(AssignedJourneyCard);
